import './index.scss'
document.addEventListener('DOMContentLoaded', function() {
    // 获取所有导航链接和章节
    const sections = document.querySelectorAll('.section');
    const progressDots = document.querySelectorAll('.progress-dot');
    
    // 设置Intersection Observer来检测章节进入视口
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.8
    };
    
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 获取当前可见章节的ID
                const currentSectionId = entry.target.id;
                
                // 为对应导航链接添加active类
                const correspondingNavLink = document.querySelector(`.nav-link[href="#${currentSectionId}"]`);
                if (correspondingNavLink) {
                    correspondingNavLink.classList.add('active');
                }
                
                // 更新进度指示器
                progressDots.forEach(dot => {
                    dot.classList.remove('active');
                    if (dot.dataset.section === currentSectionId) {
                        dot.classList.add('active');
                    }
                });
                
                // 更新章节的active状态
                sections.forEach(section => {
                    section.classList.remove('active');
                });
                entry.target.classList.add('active');
            }
        });
    }, observerOptions);
    
    // 开始观察每个章节
    sections.forEach(section => {
        observer.observe(section);
    });
    
    // 为进度指示器添加点击事件
    progressDots.forEach(dot => {
        dot.addEventListener('click', function() {
            const sectionId = this.dataset.section;
            const targetSection = document.getElementById(sectionId);
            
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
            
        });
    });
    
});

 $(window).on('scroll', function() {
    var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
    var modulePosition = $('.faq .content').offset().top; // 获取目标模块的顶部位置
    var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
    // 检查是否滚动到了模块的顶部或底部（根据需要选择）
    if (scrollPosition >= modulePosition ) { // 到达顶部（可根据需要调整距离）
        $(".faq .progress-indicator").addClass("fixed");
    }else {
        $(".faq .progress-indicator").removeClass("fixed");
    }
});

$(".content ul li").click(function() {
    $(this).find(".text").slideToggle();
    $(this).toggleClass("active");
})
$(".progress-dot").click(function() {
    let id = $(this).attr("data-section").split("#").pop()
    var top = $('#' + id).offset().top;
    console.log(id);
    $('html,body').animate({
        scrollTop: top - 150
    }, 500);
  })